<template>
  <content-container title="全部合同" :table-row-count="tableData.length">
    <!-- 搜索条件区域 -->
    <search-container>
      <search-col>
        <el-input v-model="params.contractNo" placeholder="合同编号" clearable @keydown="onEnter" />
      </search-col>
      <search-col>
        <el-input v-model="params.contractSubject" placeholder="合同主题" clearable @keydown="onEnter" />
      </search-col>
      <search-col v-if="!isHnFreePartners">
        <el-select
          v-model="params.contractType"
          placeholder="合同类型"
          clearable
          filterable
        >
          <el-option :label="contractTypeConfig[EContractType.FREE_CONTRACT]" :value="EContractType.FREE_CONTRACT" />
          <el-option :label="contractTypeConfig[EContractType.OFFLINE_CONTRACT]" :value="EContractType.OFFLINE_CONTRACT" />
          <el-option :label="contractTypeConfig[EContractType.INVALID_CONTRACT]" :value="EContractType.INVALID_CONTRACT" />
          <el-option v-if="from=='server'||from=='company'" :label="contractTypeConfig[EContractType.CROWDSOURCING]" :value="EContractType.CROWDSOURCING" />
          <el-option v-if="from=='server'||from=='company'" :label="contractTypeConfig[EContractType.CROWDSOURCING_LABOR]" :value="EContractType.CROWDSOURCING_LABOR" />
          <el-option v-if="from=='server'||from=='company'" :label="contractTypeConfig[EContractType.BROKERLABOR]" :value="EContractType.BROKERLABOR" />
        </el-select>
      </search-col>
      <search-col>
        <el-select
          v-model="params.contractStatus"
          placeholder="合同状态"
          clearable
          filterable
        >
          <el-option :label="contractStatusConfig[EContractStatus.NOT_EFFECTIVE]" :value="EContractStatus.NOT_EFFECTIVE" />
          <el-option :label="contractStatusConfig[EContractStatus.IN_EFFECT]" :value="EContractStatus.IN_EFFECT" />
          <el-option :label="contractStatusConfig[EContractStatus.EXPIRED]" :value="EContractStatus.EXPIRED" />
        </el-select>
      </search-col>
      <search-col>
        <el-select
          v-model="params.signStatus"
          placeholder="签署状态"
          clearable
          filterable
        >
          <el-option :label="contractSignStatusConfig[EContractSignStatus.TO_BE_SIGNED]" :value="EContractSignStatus.TO_BE_SIGNED" />
          <el-option :label="contractSignStatusConfig[EContractSignStatus.SIGNED]" :value="EContractSignStatus.SIGNED" />
          <el-option :label="contractSignStatusConfig[EContractSignStatus.ALREADY_OVERDUE]" :value="EContractSignStatus.ALREADY_OVERDUE" />
          <el-option :label="contractSignStatusConfig[EContractSignStatus.REJECTED]" :value="EContractSignStatus.REJECTED" />
          <el-option :label="contractSignStatusConfig[EContractSignStatus.INVALID]" :value="EContractSignStatus.INVALID" />
          <el-option :label="contractSignStatusConfig[EContractSignStatus.REVOKED]" :value="EContractSignStatus.REVOKED" />
        </el-select>
      </search-col>
      <search-col>
        <el-select
          v-model="params.actor"
          placeholder="签署方"
          clearable
          filterable
        >
          <el-option
            v-for="item in actorOption"
            :key="item.actorName"
            :label="item.actorName"
            :value="item.platformId"
          />
        </el-select>
      </search-col>
      <search-col>
        <el-date-picker
          v-model="dateRange1"
          style="width: 100%;"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD"
          :default-time="defaultTimeFormat"
          start-placeholder="截止时间(起)"
          end-placeholder="截止时间(止)"
          @keydown="onEnter"
        />
      </search-col>
      <search-col>
        <el-date-picker
          v-model="dateRange2"
          style="width: 100%;"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD"
          :default-time="defaultTimeFormat"
          start-placeholder="签署时间(起)"
          end-placeholder="签署时间(止)"
          @keydown="onEnter"
        />
      </search-col>
      <search-col>
        <el-date-picker
          v-model="dateRange3"
          style="width: 100%;"
          type="daterange"
          value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD"
          :default-time="defaultTimeFormat"
          start-placeholder="合同到期(起)"
          end-placeholder="合同到期(止)"
          @keydown="onEnter"
        />
      </search-col>
      <search-col>
        <el-input v-model="params.remark" placeholder="备注" clearable @keydown="onEnter" />
      </search-col>

      <template #buttons>
        <el-button @click="resetForm">
          <svg-icon icon="tabler:refresh" />重置
        </el-button>
        <el-button type="primary" @click="doSearch">
          <svg-icon icon="lucide:search" />查询
        </el-button>
      </template>
    </search-container>

    <!-- 非搜索区域的额外按钮 -->
    <div>
      <el-button class="mb-[20px]" @click="exportTable">
        <svg-icon icon="mingcute:file-export-line" />导出
      </el-button>
      <el-button class="mb-[20px]" @click="downnloadContract">
        <svg-icon icon="mingcute:file-export-line" />下载合同
      </el-button>
    </div>

    <!-- 表格数据 -->
    <el-table v-loading="loading" class="normal-table" :border="true" :scrollbar-always-on="true" :data="tableData" :cell-style="initOperatorColumnStyle" tooltip-effect="dark nhb-max-w-500">
      <el-table-column align="left" prop="contractNo" label="合同编号" :width="170" show-overflow-tooltip />
      <el-table-column align="left" prop="contractSubject" label="合同主题" :min-width="140" show-overflow-tooltip />
      <el-table-column v-if="!isHnFreePartners" align="left" prop="contractType" label="合同类型" :min-width="100" show-overflow-tooltip>
        <template #default="scope">
          {{ contractTypeConfig[scope.row.contractType] }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="contractStatus" label="合同状态" :width="100" show-overflow-tooltip>
        <template #default="scope">
          <custom-tag :label="contractStatusConfig[scope.row.contractStatus]" :type="contractStatusStyle[scope.row.contractStatus]" />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="signStatus" label="签署状态" :width="100" show-overflow-tooltip>
        <template #default="scope">
          <custom-tag :label="contractSignStatusConfig[scope.row.signStatus]" :type="contractSignStatusStyle[scope.row.signStatus]" />
        </template>
      </el-table-column>
      <el-table-column align="center" prop="actor" label="签署方" :width="100" show-overflow-tooltip>
        <template #default="scope">
          <el-popover
            placement="bottom-start"
            :title="`签署方（${currentRowActorInfo.length}）`"
            width="375"
            trigger="click"
          >
            <template #reference>
              <el-link type="primary" :underline="false" @click="handleClickSearch(scope.row)">
                查看
              </el-link>
            </template>
            <ul>
              <li v-for="item in currentRowActorInfo" :key="item.name" class="flex justify-between border-solid border-b border-[#EBEEF5]  h-10 items-center">
                <div class="w-[157px]">
                  {{ item.name }}
                </div> <el-link :type="contractSignStatusStyle[Number(item.status)]" :underline="false">
                  ● {{ contractSignStatusConfig[Number(item.status)] }}
                </el-link>
              </li>
            </ul>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="remark" label="备注" :min-width="140" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.remark || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="endTime" label="截止时间" :width="170" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.endTime || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="finishTime" label="签署时间" :width="170" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.finishTime || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="expireTime" label="合同到期时间" :width="170" show-overflow-tooltip>
        <template #default="scope">
          {{ scope.row.expireTime || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="buttons.length > 0"
        align="center"
        prop="actions"
        fixed="right"
        label="操作"
      >
        <template #default="scope">
          <table-row-buttons :buttons="buttons" :row="scope.row" />
        </template>
      </el-table-column>
    </el-table>

    <!-- 底部分页 -->
    <template #footer>
      <el-pagination
        v-model:current-page="params.page"
        v-model:page-size="params.size"
        :page-sizes="[defaultPageSize, 25, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        @size-change="onSizeChange"
        @current-change="onCurrentPageChange"
      />
    </template>
  </content-container>
</template>

<script setup lang="ts">
import { downloadFile, getFomattedTimeRange } from '@core/tools';
import { reactive, ref, PropType, computed } from 'vue';
import { ElMessage } from 'element-plus';
import { SvgIcon, CustomTag, TableRowButtons, initOperatorColumnStyle } from '@vue3/components';
import { ContentContainer, SearchContainer, SearchCol, useTblPermissionButtons, queryContractSignPage, queryContractSignDownload, queryContractSignPreview, contractSignExport, queryContractCreateActorInfo, queryContractSignActorSign, queryContractSignDrapDown, useUserStore } from '../../../..';
import {
  EContractType,
  EContractStatus,
  contractTypeConfig,
  contractStatusConfig,
  contractSignStatusConfig,
  contractSignStatusStyle,
  EContractSignStatus,
  contractStatusStyle,
  IContractActorListVO,
  serverCrowdCreditCode,
} from '@core/main/types';

defineOptions({ name: 'AllMyContract' });

const { state: userState } = useUserStore();

const props = defineProps({
  from: {
    type: String as PropType<'saas' | 'company' | 'agent' | 'server'>,
    default: 'saas',
  },
});

const defaultTimeFormat = computed (() => getFomattedTimeRange());

const defaultPageSize = 10;

const params = reactive<any>({
  page: 1,
  size: defaultPageSize,
});

const loading = ref(false);
const total = ref(0);
const tableData = ref([]);
const dateRange1 = ref<string[]>([]);
const dateRange2 = ref<string[]>([]);
const dateRange3 = ref<string[]>([]);
const contractIds = ref([] as number[]);
const actorOption = ref([]);
const currentRowActorInfo = ref<IContractActorListVO[]>([]);

const isServer = computed(() => props.from === 'server');
const isHnFreePartners = computed(() => serverCrowdCreditCode?.includes(userState.identity?.serverDTO?.creditCode) && isServer.value);

const { buttons } = useTblPermissionButtons([
  {
    name: '预览',
    action: toPreview,
  },
  {
    name: '签署',
    code: 'contract:sign:sign',
    relationField: 'canSign',
    relationValue: 1,
    action: toSign,
  },
  {
    name: '下载',
    action: toDownload,
  },
]);

async function handleClickSearch(row) {
  try {
    const res = await queryContractCreateActorInfo(row.contractId);

    currentRowActorInfo.value = res;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function toSign(row) {
  try {
    const url = await queryContractSignActorSign(row.id);

    window.open(url);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function exportTable() {
  try {
    const res = await contractSignExport(params);

    downloadFile(res, '', 'xlsx');
    ElMessage.success('导出成功');
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function downnloadContract() {
  contractIds.value = tableData.value.map((v) => v.contractId);

  if (contractIds.value.length === 0) return ElMessage.warning('请先选择需要下载的合同');

  try {
    const url = await queryContractSignDownload({
      ...params,
      ids: contractIds.value,
    });

    window.open(url);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

}

async function toPreview(row) {
  try {
    const res = await queryContractSignPreview(row.contractId);

    window.open(res);
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function toDownload(row) {
  try {
    const url = await queryContractSignDownload({
      page: 1,
      size: 10,
      ids: [row.contractId],
    });

    window.open(url);
    // if (row.contractType == EContractType.OFFLINE_CONTRACT) {
    //   const x = new window.XMLHttpRequest();

    //   x.open('GET', url, true);
    //   x.responseType = 'blob';
    //   x.onload = () => {
    //     const newUrl = window.URL.createObjectURL(x.response);
    //     const a = document.createElement('a');

    //     a.download = row.contractSubject;
    //     a.href = newUrl;
    //     a.target = '_block';
    //     a.click();
    //     document.removeChild(a);
    //   };
    //   x.send();
    // } else {
    //   window.open(url);
    // }
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function fetchData() {
  loading.value = true;

  try {
    const { data, total: all } = await queryContractSignPage({
      ...params,
      endTimeStart: dateRange1.value?.[0],
      endTimeEnd: dateRange1.value?.[1],
      finishTime: dateRange2.value?.[0],
      finishTimeEnd: dateRange2.value?.[1],
      expireTimeStart: dateRange3.value?.[0],
      expireTimeEnd: dateRange3.value?.[1],
    });

    tableData.value = data;
    total.value = all;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

function resetForm() {
  dateRange1.value = [];
  dateRange2.value = [];
  dateRange3.value = [];
  for (const key in params) {
    if (!['page', 'size'].includes(key)) {
      params[key] = '';
    }
  }
}

function onSizeChange(size: number) {
  params.size = size;
  params.page = 1;
  fetchData();
}

function onCurrentPageChange(page: number) {
  params.page = page;
  fetchData();
}

function doSearch() {
  params.page = 1;
  fetchData();
}

function onEnter(e) {
  if (e.keyCode === 13) doSearch();
}

async function fetchDrapDownCreate() {
  try {
    const { actorList } = await queryContractSignDrapDown();

    actorOption.value = actorList;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function init() {
  await fetchData();
  await fetchDrapDownCreate();
}

init();

</script>
